import cn from 'classnames';
import * as React from 'react';

import { RadioProps } from 'shared/newEntities/components/Radio';
import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';

import './Radio.modules.scss';

const Radio: React.FC<RadioProps> = ({
  name,
  value,
  checked,
  onChange,
  children,
  disabled = false,
  className
}: RadioProps) => {
  const handleChange = React.useCallback(() => {
    if (disabled) {
      return;
    }

    onChange();
  }, [disabled, onChange]);

  return (
    <label
      styleName={cn('radio', disabled && 'radio_disabled')}
      className={className}
    >
      <input
        styleName="radio__input"
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
      />
      <span styleName="radio__control" aria-hidden="true">
        <span styleName={cn('radio__dot', checked && 'radio__dot_checked')} />
      </span>
      <Typography
        fontType={TypographyType.text}
        fontSize={TypographySize.s}
        fontWeight={TypographyWeight.heavy}
        fontColor={TypographyColor.secondary}
      >
        {children}
      </Typography>
    </label>
  );
};

export default Radio;
